export const fbAppId = process.env.FB_APP_ID;
